import { message } from 'antd';

import { IBuilderSaveResult } from 'components/EmbeddedBuilder';
import API from 'utils/request';
import serializeFormData from 'utils/serializeFormData';

import { AudienceFormValues } from './audienceAdapter';

const TOAST_KEY = 'orbit-audience-submit';

const FALLBACK = 'Error creating the Audience.';

interface IApiError {
  message?: string;
  response?: { data?: { message?: string; error?: string; errors?: string[] } };
}

/**
 * Creates the audience as the module form does (`Audience/form/index.tsx`): a multipart body
 * whose `_payload` holds the JSON, no uploaded groups. Audiences have no maker-checker. Rejects
 * with the API's message (the module form's own wording), which the sheet shows inline.
 */
export const saveAudience = async (values: AudienceFormValues): Promise<IBuilderSaveResult> => {
  let id: number | undefined;
  try {
    const formData = serializeFormData({ _payload: JSON.stringify(values), user_groups: [] });
    const response = await API.post('/v4/dash/v4_audiences', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    id = response?.data?.data?.id;
  } catch (error) {
    const data = (error as IApiError)?.response?.data;
    const apiMessage =
      data?.message ||
      data?.error ||
      (Array.isArray(data?.errors) ? data?.errors.join(', ') : null);
    throw new Error(apiMessage || (error as IApiError)?.message || FALLBACK);
  }
  if (id === undefined) {
    throw new Error(FALLBACK);
  }
  message.success({ content: 'File Upload Success', key: TOAST_KEY });
  return { entity: 'audience', id };
};
